import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"

const ResultsPreview = ({
  bgImage,
  question = "",
  options = [],
  menu_bg_color,
  chartType = "0",
}) => {
  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
          boxShadow: "inset 0 0 0 500px rgb(0 0 0 / 50%)",
        }}
      >
        <div
          className="col-auto py-1 px-1 mb-3"
          style={{
            width: "90%",
            height: "70px",
            display: "flex",
            margin: "0 auto",
            flexDirection: "column",
            justifyContent: "space-between",
            borderBottom: "1px solid white",
          }}
        >
          <i
            className="bx bx-menu font-size-24"
            style={{ cursor: "pointer", color: "gray", marginLeft: "-10px" }}
          />
          <p
            style={{
              textAlign: "center",
              color: "white",
              fontSize: "12px",
              margin: "0px",
            }}
          >
            {question}
          </p>
        </div>
        <div
          style={{
            width: "90%",
            margin: "0 auto",
            borderBottom: "1px solid white",
            paddingBottom: "5px",
          }}
        >
          <p style={{ margin: "0px", color: "white", textAlign: "center" }}>
            POLL RESULTS
          </p>
          <p
            className="mt-2"
            style={{ margin: "0px", color: "white", textAlign: "center" }}
          >
            {`You answered: "${options[0]?.answer ? options[0]?.answer : ""}"`}
          </p>
          <div className="my-2" style={{ textAlign: "center" }}>
            <img
              src={
                chartType === "0"
                  ? "https://admin.dev.markedprivate.com/app/images/preview/poll-concentric.png"
                  : chartType === "1"
                  ? "https://admin.dev.markedprivate.com/app/images/preview/poll-horizontal.png"
                  : "	https://admin.dev.markedprivate.com/app/images/preview/poll-pie.png"
              }
              style={{
                maxWidth: chartType === "1" ? "80%" : "50%",
                maxHeight: "50%",
              }}
            />
          </div>
          {options?.map(
            (option, index) =>
              option?.answer && (
                <p key={index} style={{ margin: "0px", color: "white" }}>
                  <i
                    className="bx bxs-square"
                    style={{
                      color: menu_bg_color,
                      cursor: "pointer",
                      verticalAlign: "middle",
                    }}
                  />
                  {option?.answer}
                </p>
              )
          )}
        </div>
        <p style={{ color: "white", textAlign: "center" }}>
          THANK YOU FOR VOTING!
        </p>
      </div>
    </PhoneArea>
  )
}

export default ResultsPreview
